/* -------------------------------------------------------------------------------------------------
 * helpers
 * -----------------------------------------------------------------------------------------------*/
function loadAdobeLaunchScript() {
  try {
    const script = createAdobeLaunchScript();
    document.body.appendChild(script);
    return script;
  } catch (error) {
    console.error('Error in loadAdobeLaunchScript', error);
  }
}

function createAdobeLaunchScript() {
  const scriptUrl = new URL(window.APP_ADOBE_LAUNCH_URL);

  const script = document.createElement('script');

  script.async = true;
  script.src = scriptUrl.href;
  script.setAttribute('id', 'adobe-launch-script');

  return script;
}

function logTrackingEvent(dataLayer: any) {
  const allowedEnvs = ['test', 'development'];
  if (allowedEnvs.includes(window.AR_DEPLOY_ENV)) {
    console.log('analytics-event', dataLayer);
  }
}

function trackAnalyticsEvent(data: { [key: string]: string }) {
  try {
    logTrackingEvent(data);
    window.adobeDataLayer?.push(data);
  } catch (error) {
    console.error('Error in adobeDataLayer.push', error);
  }
}

export { loadAdobeLaunchScript, trackAnalyticsEvent };
